import htmr from 'htmr';

// to render html
export const html = (text) => {

    try {
        return htmr(text).replace("&gt;",">");
    }
    catch(exception){
        if(exception){
            return text;
        }
    }
}

// to change database newlines to html newlines
export const newlines = (text) => {

    try {
        return text.replace(/\n/g, '<br />');
    }
    catch(exception){
        if(exception){
            return text;
        }
    }
}

// to remove accents, etc.
export const cleanString = (text) => {

    try{
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    catch(exception){
        if(exception){
            return text;
        }
    }

}

// format prices
export const price = (priceValue, currency = 'euro') => {

    if(typeof priceValue !== 'undefined' && priceValue !== null){

        const priceFormatted = priceValue.toFixed(2);

        var symbol = '';
        switch(currency){

            case 'euro':
            default:
                symbol = '€';
                break;
        }

        return priceFormatted+symbol;
    }
    else{
        return priceValue;
    }
}

// format prices on the ag grid
export const priceFormatter = (params,table,column) => {
    // to avoid error with eslint
    if(table && column){
        const priceString = params.value;
        return price(priceString,true);
    }
}

// format percentage
export const percentage = (percentageValue, decimals = true) => {

    if(typeof percentageValue !== 'undefined' && percentageValue !== null){

        var percentageNumber = parseFloat(percentageValue);

        let decimalsNumber;
        if(decimals){
            decimalsNumber = 2;
        }
        else{
            decimalsNumber = 0;
        }
     
        const percentageFormatted = percentageNumber.toFixed(decimalsNumber);

        return percentageFormatted+'%';
    }
    else{
        return percentageValue;
    }
}

// format percentage on the ag grid
export const percentageFormatter = (params,table,column, decimals = true) => {
    const percentageString = params.value;
    return percentage(percentageString,decimals);
}

// format sizes (sizes are in bytes)
// b,B,KB,MB,GB
export const size = (sizeValue, scale = 'MB', decimals = 2) => {

    if(typeof sizeValue !== 'undefined' && sizeValue !== null){

        var factor = 1;
        switch(scale){

            case 'b':
                factor = 1/8; // same as x8
                break;

            case 'KB':
                factor = 1024; // same as x8
                break;

            case 'MB':
                factor = 1024*1024; // same as x8
                break;

            case 'GB':
                factor = 1024*1024*1024; // same as x8
                break;
        }

        const sizeFormatted = (sizeValue/factor).toFixed(decimals);

        return sizeFormatted+scale;
    }
    else{
        return sizeValue;
    }
}

// get video format for the input rich text
export const videoFormat = (link,type = 'youtube') => {

    //'https://www.youtube.com/watch?v=7fkQwAz-5go&a=3';
    var resul = link;

    if(link && link.length > 0){

        if(type === 'youtube'){

            var split = link.split('v=');

            if(split.length > 1){

                var string = split[1];
                var split2 = string.split('&');

                resul = split2[0];

                return 'https://www.youtube.com/embed/'+resul;
            }
            else{
                resul = split[0];
                return resul;
            }
        }
        else{
            return resul;
        }
    }
    else{
        return resul;
    }
}

// transform data to formData just in case we have files
export const getFormData = (columns,dataFormatted,params = null,files = []) => {

    const formData = new FormData();

    // check file types
    const fileColumns = [];
    
    if(columns && Object?.keys(columns)){
        Object?.keys(columns)?.map((column) => {
            if(columns[column]?.type === 'file'){
                fileColumns.push(column);
            }
        });
    }

    if(files && files?.length > 0){
        fileColumns.push(...files);
    }

    // add fields to formData
    const fileFields = [];
    for(const key in dataFormatted){

        if(Object.hasOwn(dataFormatted,key)){ 

            // check it is not file type  
            if(!fileColumns.includes(key)){
                formData.append(key,dataFormatted[key]);
            }
            else{
                // get file fields to analyze below
                fileFields.push(key);
            }
        }
    }

    // add extra params
    if(params && Object?.keys(params)){
        Object?.keys(params)?.map((param) => {
            formData.append(param,params[param]);
        });
    }

    // check if files
    if(fileFields && fileFields?.length > 0){

        fileFields?.map((field) => {

            var counter = 0;
            var filesData = dataFormatted[field];

            filesData && filesData?.forEach((fileObject,index) => {            
               
                if(fileObject.upload instanceof File || fileObject.upload instanceof Blob){

                    // generate unique name
                    const uniqueKey = `file_${counter++}`;                                                
                    formData.append(uniqueKey,fileObject.upload,fileObject.upload.name);

                    // change file data to the key to use when uploaded to server
                    filesData[index].upload = uniqueKey;
                }
            });

            // transform object into json to send to server
            formData.append(field,JSON.stringify(filesData));            
        });
    }

    return formData;
}